import NextImage, { ImageProps as NextImageProps } from 'next/image';
import { ForwardedRef, forwardRef, memo } from 'react';

import { SiteLocale } from 'constants/i18n.constants';
import { IMAGE_BLUR_PLACEHOLDER } from 'constants/images.constants';
import { useLocale } from 'hooks/useLocale';
import { ImageFileFragment } from 'types/api/dato-operations.types';

const fallback = '/images/fallback.webp';

const altFallbackLookup = {
  [SiteLocale.EN]: 'Abstract black background with white lines',
  [SiteLocale.AR]: 'خلفية سوداء مع خطوط بيضاء',
};

interface ImageProps
  extends Omit<NextImageProps, 'src' | 'alt' | 'layout' | 'objectFit'> {
  data?: ImageFileFragment;
}

const DatoImage = (
  {
    data,
    placeholder = 'blur',
    blurDataURL = IMAGE_BLUR_PLACEHOLDER,
    ...rest
  }: ImageProps,
  // Not sure this works well with framer-motion
  _ref: ForwardedRef<HTMLImageElement>,
) => {
  const { locale } = useLocale();

  const src = data?.url;

  const blurData = data?.blurUpThumb ?? blurDataURL;

  const isFallback = !src;

  return (
    <NextImage
      key="image"
      src={!isFallback ? src : fallback}
      alt={!isFallback ? (data?.alt ?? '') : (altFallbackLookup[locale] ?? '')}
      unoptimized={isFallback}
      blurDataURL={blurData}
      placeholder={placeholder}
      {...rest}
    />
  );
};

DatoImage.displayName = 'DatoImage';

export default memo(forwardRef(DatoImage));
